import { SortDirection } from '@empathy/search-types';
import { COMPONENTS } from '../../../components/components.registry';
import { SortConfig } from '../../../models';

export const DEFAULT_SORT_CONFIG: SortConfig = {
  components: {
    sort: COMPONENTS.PURE.SortToggle,
    list: COMPONENTS.PURE.SortList,
    panel: COMPONENTS.PANELS.OverlappingPanel,
    sortIcon: null
  },
  dropdown: {
    dropdownId: 'sort-dropdown',
    expandOnHover: false
  },
  iconSlot: 'sort-toggle-icon',
  sorts: [
    {
      title: 'default',
      value: '',
      direction: null
    },
    {
      title: 'priceAsc',
      value: 'price asc',
      direction: SortDirection.ASC
    },
    {
      title: 'priceDesc',
      value: 'price desc',
      direction: SortDirection.DESC
    }
  ]
};
